import { Link } from "react-router-dom";
import { Calendar, MapPin, Ticket, Users } from "lucide-react";

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      month: "short", day: "numeric", year: "numeric",
    });
  } catch { return iso; }
};

export default function EventCard({ e, index = 0 }) {
  return (
    <Link
      to={`/events/${e.id}`}
      data-testid={`event-card-${e.id}`}
      className="group block animate-fade-up bg-white border border-sand-200 hover:shadow-xl transition-shadow"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="img-zoom aspect-[16/10] bg-sand-100 overflow-hidden relative">
        <img src={e.cover_image} alt={e.name} className="w-full h-full object-cover" loading="lazy" />
        {e.source === "community" && (
          <span className="absolute top-3 left-3 bg-forest-500 text-sand-50 font-mono text-[9px] tracking-[0.2em] uppercase px-2.5 py-1">
            Community
          </span>
        )}
      </div>
      <div className="p-7">
        <div className="flex items-center justify-between mb-4">
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-brand-500">
            {e.category}
          </span>
          <span className="font-mono text-[10px] tracking-widest uppercase text-sand-600">
            {fmtDate(e.date)}
          </span>
        </div>
        <h3 className="font-serif text-2xl font-bold text-sand-900 leading-tight group-hover:text-brand-500 transition-colors">
          {e.name}
        </h3>
        {e.host_name && (
          <div className="mt-1 font-mono text-[10px] tracking-widest uppercase text-forest-500">by {e.host_name}</div>
        )}
        <p className="mt-3 text-sm font-light text-sand-700 line-clamp-2">{e.short_description}</p>
        <div className="mt-5 pt-5 border-t border-sand-200 flex flex-wrap items-center gap-4 text-xs text-sand-700">
          <span className="flex items-center gap-1.5"><MapPin size={12} /> {e.venue || e.location}</span>
          <span className="flex items-center gap-1.5"><Ticket size={12} /> {e.ticket_price}</span>
          {e.rsvp_count > 0 && (
            <span className="flex items-center gap-1.5"><Users size={12} /> {e.rsvp_count} going</span>
          )}
        </div>
      </div>
    </Link>
  );
}
